/**
 * jk-subscription-visibility.js — Controller der NATIVEN Kaufoption
 * (Option B, Entscheid Andreas 18.08.2026; Analyse und Begruendung:
 * audit/seal-analyse-2026-08-18.md. Ersetzt die fruehere Seal-Widget-
 * Orchestrierung vollstaendig — kein Seal-DOM, keine Seal-Selektoren.)
 *
 * Markup: snippets/jk-purchase-option.liquid. Aufgaben:
 *   1. Checkbox-Toggle: an = gewaehlter Selling-Plan in den versteckten
 *      selling_plan-Input (Form-Attribut bindet an Dawns Product-Form),
 *      ab = Leerstring (Einmalkauf). Jede Aenderung dispatcht ein
 *      change-Event auf dem Input — jk-product-price.js hoert darauf
 *      (name === 'selling_plan') und rechnet den Preisblock um.
 *   2. Intervall-Select: Wechsel aktualisiert den Input bei aktivem Abo.
 *   3. Varianten-Verfuegbarkeit (Entscheid Andreas: Kaufoption NUR wenn
 *      die Variante Allocations hat — Flaschen nein, Refills ja):
 *      Initialzustand kommt serverseitig; bei Variantenwechsel wird
 *      Dawns [data-selected-variant]-JSON gelesen, die Zeile ein-/
 *      ausgeblendet und das Select auf die allozierten Plaene gefiltert.
 *   4. Mengen-Kacheln: bei 2+ Stueck ist das Abo ausgeblendet und
 *      zurueckgesetzt (Abo bleibt auf Menge 1 beschraenkt — Bestand).
 *
 * Fasst NICHT an: ATC-Submit, Preisrechnung (jk-product-price.js), Cart.
 */
(function () {
  'use strict';

  if (!document.body.classList.contains('template-product')) return;

  const root = document.querySelector('[data-jk-purchase-option]');
  if (!root) return;

  const toggle    = root.querySelector('[data-jk-po-toggle]');
  const details   = root.querySelector('[data-jk-po-details]');
  const select    = root.querySelector('[data-jk-po-select]');
  const planInput = root.querySelector('[data-jk-po-plan]');
  const desc      = root.querySelector('[data-jk-po-desc]');
  if (!toggle || !planInput) return;

  // Lieferplan-Hinweis (Wunsch Andreas 18.08.2026): description des
  // gewaehlten Plans aus der Liquid-gerenderten JSON-Map.
  let descMap = {};
  const descBlob = root.querySelector('[data-jk-po-descriptions]');
  if (descBlob) {
    try { descMap = JSON.parse(descBlob.textContent) || {}; } catch { descMap = {}; }
  }

  function updateDesc() {
    if (!desc || !select) return;
    const text = descMap[String(select.value)] || '';
    desc.textContent = text;
    desc.hidden = text === '';
  }

  // Serverseitiger Initialzustand: hidden-Attribut = Variante ohne Plaene
  let variantAvailable = !root.hidden;

  function announce() {
    // jk-product-price.js hoert dokumentweit auf change von
    // input[name="selling_plan"] — bubbles reicht.
    planInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function sync() {
    const on = toggle.checked && variantAvailable;
    if (details) details.hidden = !on;
    planInput.value = on && select ? select.value : '';
    updateDesc();
    announce();
  }

  function resetOff() {
    if (toggle.checked) toggle.checked = false;
    sync();
  }

  toggle.addEventListener('change', sync);
  if (select) select.addEventListener('change', sync);

  // ── Varianten-Verfuegbarkeit ─────────────────────────────────────

  function readVariant() {
    const blob = document.querySelector('[data-selected-variant]');
    if (!blob) return null; // Single-Variant-Produkte: kein Blob, Initialzustand gilt
    try { return JSON.parse(blob.textContent); } catch { return null; }
  }

  function applyVariant() {
    const variant = readVariant();
    if (!variant) return;
    const allocs = variant.selling_plan_allocations || [];
    variantAvailable = allocs.length > 0;

    if (select) {
      // Select auf die tatsaechlich allozierten Plaene der Variante filtern
      const allowed = {};
      allocs.forEach(function (a) { allowed[String(a.selling_plan_id)] = true; });
      let firstAllowed = null;
      Array.prototype.forEach.call(select.options, function (opt) {
        const ok = !!allowed[opt.value];
        opt.hidden = variantAvailable && !ok;
        opt.disabled = variantAvailable && !ok;
        if (ok && firstAllowed === null) firstAllowed = opt.value;
      });
      if (variantAvailable && !allowed[select.value] && firstAllowed !== null) {
        select.value = firstAllowed;
      }
    }

    if (!variantAvailable) {
      root.hidden = true;
      resetOff();
    } else {
      root.hidden = getCheckedQty() > 1;
      sync();
    }
  }

  // ── Mengen-Kacheln: Abo nur bei Menge 1 (Bestand) ────────────────

  function getCheckedQty() {
    const qb    = document.querySelector('jk-quantity-breaks');
    const radio = qb && qb.querySelector('input[type="radio"]:checked');
    return radio ? (parseInt(radio.dataset.qty || radio.value, 10) || 1) : 1;
  }

  function applyQty() {
    if (!variantAvailable) return;
    if (getCheckedQty() > 1) {
      root.hidden = true;
      resetOff();
    } else {
      root.hidden = false;
    }
  }

  const qb = document.querySelector('jk-quantity-breaks');
  if (qb) qb.addEventListener('change', applyQty);

  // ── Variantenwechsel: Dawn ersetzt den JSON-Blob-Inhalt ──────────

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      // Nach Dawns DOM-Swap lesen (rAF: Blob ist dann aktualisiert)
      requestAnimationFrame(applyVariant);
    });
  }
  const blob = document.querySelector('[data-selected-variant]');
  if (blob) {
    new MutationObserver(function () { applyVariant(); })
      .observe(blob, { childList: true, subtree: true, characterData: true });
  }

  // Initial: Input konsistent zum (unangekreuzten) Start
  sync();
})();
